import { Icons } from '@/components/atoms/icons';
import React from 'react';
import { IRRSSProps } from './RRSS.interface';
import styles from './RRSS.module.scss';

export const RRSS = (props: IRRSSProps) => {
	return (
		<div className={`rrss ${styles.rrss} ${props.className}`}>
			<a href="https://www.instagram.com/toctoccom?o=footer" target={'_blank'} rel="noreferrer"><Icons iconName='iconInstagram' /></a>
			<a href="https://www.facebook.com/toctoccom?o=footer" target={'_blank'} rel="noreferrer"><Icons iconName='iconFacebook'/></a>
			<a href="https://www.linkedin.com/company/toctoc.com?o=footer" target={'_blank'} rel="noreferrer"><Icons iconName='iconLinkedin' /></a>
			<a href="https://www.youtube.com/user/TocTocChile?o=footer" target={'_blank'} rel="noreferrer"><Icons iconName='iconYoutube' /></a>
		</div>
	);
};